/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */



(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        $(document).foundation(); // Foundation JavaScript
        
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);




})(jQuery); // Fully reference jQuery after this point.


jQuery(document).ready(function(){      // global document.ready

    jQuery('.tour_choose_slider').flipster({
        itemContainer: 'ul',
        itemSelector: 'li',
        scrollwheel: false,
        buttons: true,
        touch: true,
    });

    jQuery(window).scroll(function () {
      var header =  jQuery('header');

      if(header.hasClass('header_fixed') === false){
          if(jQuery(this).scrollTop() > 25){
              header.removeClass('scroll_off');
              header.addClass('scroll_on').fadeIn(300);
          } else {
              header.removeClass('scroll_on').fadeIn(300);
              header.addClass('scroll_off');
          }
      }

    });


    jQuery(".c-hamburger").click(function() {
        jQuery(this).toggleClass('is-active');
        var nav = jQuery('nav');
        if (nav.is(":visible")) {
            nav.fadeOut(600, function () {
                if( nav.attr('style','display') ==='none'){
                    nav.removeAttr('style');
                }

                jQuery('.select_language li span').removeAttr('style');

            });
        } else {
            nav.fadeIn(600);
            jQuery('.select_language li span').css('color', '#fff');
        }
    });



    jQuery('#arrow_up').click(function(e) {
        jQuery('html, body').animate({scrollTop: 0},500);
        e.preventDefault();
    });



    jQuery('.select_experience,.select_duration,.enter_number').change( function () {
        jQuery(this).css({'border-bottom': "2px solid #07ED00",
                             'border-top': "2px solid #07ED00",
                            'border-left': "2px solid #07ED00",
                            'border-right': "none"
        });
    });









//=============== Review slider =================\\

    jQuery('.review_container').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        arrows: true,
        draggable : false,
        nextArrow: ".control_panel button.arrow_next_review",
        prevArrow: ".arrow_prev_review",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    draggable : true,
                    arrows: true,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true
                }
            },
            {
                breakpoint: 640,
                settings: {
                    draggable : true,
                    arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true
                }
            }

        ]
    });

//=============== one_tour_slider in intro =================\\

    jQuery('.one_tour_slider').slick({
        nextArrow: '.one_tour_slider_nav_arrow_rigth',
        prevArrow : '.one_tour_slider_nav_arrow_left',
        // draggable : false,
        autoplay: true,
        autoplaySpeed : 15000
    });

//=============== one_tour_slider_road =================\\

    jQuery('.tour_slider_road').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        asNavFor: '.tour_slider_road_nav',
        arrows:  false
    });

    jQuery('.tour_slider_road_nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.tour_slider_road',
        focusOnSelect: true,
        infinite: false,
        arrows: true,
        nextArrow: "button.slider_nav_block_btn_next",
        prevArrow: "button.slider_nav_block_btn_prev",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 3,
                }
            }

        ]
    });

//=============== MENU SLIDER ONE TOUR =================\\

jQuery('.food_info_list').slick({
    slidesToShow: 3,
    draggable : false,
    infinite: false,
    arrows: true,
    nextArrow: "button.next_day",
    prevArrow: "button.prev_day",
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                draggable : true,
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: false
            }
        },
        {
            breakpoint: 640,
            settings: {
                draggable : true,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true
            }
        }

    ]
});

//=============== TOUR SLIDER PREVIEW =================\\

    // jQuery('.tour_container').slick({
    //     slidesToShow: 3,
    //     slidesToScroll: 3,
    //     infinite: false,
    //     arrows: false,
    //     responsive: [
    //         {
    //             breakpoint: 1140,
    //             settings: {
    //                 arrows: true,
    //                 nextArrow: "button.next_tour",
    //                 prevArrow: "button.prev_tour",
    //                 slidesToShow: 2,
    //                 slidesToScroll: 2,
    //                 infinite: true
    //             }
    //         },
    //         {
    //             breakpoint: 640,
    //             settings: "unslick"
    //         }
    //     ]
    // });


//=============== Animation pimpocka =================\\

    var elements =  jQuery('.pimp_container li').hide();
    var big_elements = jQuery('.pimp_container-big li').show();
    var days_pimp =jQuery('.time_table li .pimp_blue').hide();

    function showElements(selector) {
        selector.each(function(i)
        {
            jQuery(this).delay(500*i).fadeIn(500);
        });
    }

    showElements(days_pimp);
    showElements(elements);



//=============== CALENDAR =================\\

    jQuery('.event_item .number_date').css({'color': '#ffffff'});

//=============== Form =================\\

    var pattetn_number = /[0-9]/;

    var pattern_email = /^[-._a-z0-9]+@(?:[a-z0-9][-a-z0-9]+\.)+[a-z]{2,6}$/i;

    var name = jQuery('#name_client');
    var email = jQuery('#email_client');
    var count = jQuery('#count_client');
    var phone = jQuery('#phone_client');
    var age = jQuery('#age_client');
    var height = jQuery('#height_client');

    jQuery('input').keydown( function(e){
        if(e.keyCode === 13){
            e.preventDefault();
        }
    });

    jQuery('button').click( function (e) {
       e.preventDefault();
    });


    //=============== validate one step =================\\


    jQuery(' .step_one .rqfield').addClass('empty_field');

    function lightempty() {
        jQuery('.step_one').find('.empty_field').addClass('error_input');

        if(jQuery('.step_two').is(':visible')){
            jQuery('.step_two').find('#equipment input:radio').addClass('no_validate');
        }
        setTimeout(function () {
            jQuery('.step_one').find('.empty_filed').removeClass('error_input');
            jQuery('.step_two #equipment ').removeClass('no_validate');
        },1000);
    }


    function only_number_input(selector) {
        selector.keydown(function(e){

            if((e.which >=48 && e.which <=57)  || (e.which >=96 && e.which <=105) || e.which === 8 || (e.which >= 37 && e.which <=40) || e.which === 46)
            {
                return true;
            } else {
                return false;
            }
        });
        selector.blur(function () {
            if(selector.val() !== ''){
                jQuery(this).removeClass('empty_field').removeClass('error_input').addClass('validate_input');
            }
            else{
                jQuery(this).removeClass('validate_input').addClass('error_input');
            }
        });
    }


    name.blur(function () {
       if(name.val() !== ''){
           if(name.val().length > 5 && name.val().search(pattetn_number) === -1 ){
               jQuery(this).removeClass('empty_field').removeClass('error_input').addClass('validate_input');
           }else{
               jQuery(this).removeClass('validate_input').addClass('error_input');
           }
       } else{
           jQuery(name).removeClass('validate_input').addClass('error_input');
       }
    });

    email.blur(function () {
        if(email.val() !== ''){
            if(email.val().search(pattern_email) === 0 ){
                jQuery(this).removeClass('empty_field').removeClass('error_input').addClass('validate_input');
            }else{
                jQuery(this).removeClass('validate_input').addClass('error_input');
            }
        } else{
            jQuery(email).removeClass('validate_input').addClass('error_input');
        }
    });

    only_number_input(count);
    only_number_input(phone);
    only_number_input(age);
    only_number_input(height);



    if(jQuery('.section_registration').length){

        var weight_range = document.getElementById('weight_range');

        noUiSlider.create(weight_range, {
            connect: true,
            behaviour: 'tap',
            start: [
                60,
                70
            ],
            // step: 10,
            range: {
                'min': 40,
                'max': 120
            }
        });

    }



    //VALUE

   // weight_range.noUiSlider.on('update',function (values,handle) {
   //     console.log(values[handle]);
   // });

    //=============== validate second step =================\\

    jQuery('#equipment').change(function () {
        jQuery('#equipment input:radio').removeClass('no_validate');
        if(jQuery('#equipment input:radio:checked').length > 0){
            jQuery(this).addClass('validate_input');
            jQuery('.step_two .next_form').removeClass('disabled_step');
        }
    });

    jQuery('.step_two .next_form').on('click', function () {
        if(jQuery(this).hasClass('disabled_step')){
            jQuery('#equipment input:radio').addClass('no_validate');
        }
    });


    jQuery('#equipment_desire input:radio').change(function () {
        jQuery('#equipment_shop').fadeIn(300);
    });

    //=============== validate third step =================\\

    jQuery('.food_in_tour input:checkbox').change(function () {
        if( jQuery(this).prop('checked')){
            jQuery(this).removeClass('error_input').addClass('validate_input');
            jQuery('.progres_steps li:last-child').addClass('complete');
        } else{
            jQuery(this).removeClass('validate_input').addClass('error_input');
            jQuery('.progres_steps li:last-child').removeClass('complete');
        }
    });

    jQuery('.food_in_tour :checkbox').change(function () {
        if (this.id === "eat_all") {
            jQuery('.food_in_tour :checkbox:not(#eat_all)').prop("checked", false);
        }
        else {
            jQuery("#eat_all").prop("checked", false);
        }
    });

    jQuery('textarea').blur(function () {
        if(jQuery(this).val() !== '' ){
            jQuery(this).css('border','2px solid #00b800');
        } else{
            jQuery(this).removeAttr('style');
        }
    });

    //=============== Logic form =================\\

    if(jQuery('.section_registration').length){
        setInterval(function () {

            var validTrue = jQuery('.validate_input').length;

            if( validTrue === 6){
                jQuery('.step_one').find('.next_form').removeClass('disabled_step');
            } else if (validTrue === 7){
                jQuery('.step_two').find('.next_form').removeClass('disabled_step');
            } else if (validTrue >= 8 && jQuery('.complete').length === 3){
                jQuery('.section_registration input[type="submit"]').fadeIn(300);
            }  else {
                jQuery('.section_registration input[type="submit"]').hide();
            }
            console.log(validTrue);
        },500);
    }

    //=============== move form and steps =================\\

    var current_fs, next_fs, previous_fs;

    var fieldset = jQuery('fieldset');

    jQuery('.next_form').on('click',function () {

        if(jQuery(this).hasClass('disabled_step')){
            lightempty();
        }   else {

            current_fs = jQuery(this).parent().parent();
            next_fs = jQuery(this).parent().parent().next();

            jQuery('.progres_steps li').eq(jQuery('fieldset').index(next_fs)).addClass('active');
            jQuery('.progres_steps li').eq(jQuery('fieldset').index(next_fs)).find('.pimp').addClass('pimp_active');
            jQuery('.progres_steps li').eq(jQuery('fieldset').index(current_fs)).addClass('complete');
            jQuery('.progres_steps li').eq(jQuery('fieldset').index(current_fs)).find('.pimp').removeClass('pimp_active');

            next_fs.show();
            current_fs.hide();
        }

    });

    jQuery(".prev_form").click(function(){
        current_fs = jQuery(this).parent().parent();
        previous_fs = jQuery(this).parent().parent().prev();

        jQuery(".progres_steps li").eq(jQuery("fieldset").index(current_fs)).removeClass("active");
        jQuery(".progres_steps li").eq(jQuery("fieldset").index(current_fs)).find('.pimp').removeClass('pimp_active');
        jQuery(".progres_steps li").eq(jQuery("fieldset").index(previous_fs)).find('.pimp').addClass('pimp_active');

        previous_fs.show();
        current_fs.hide();
    });

    jQuery('.progres_steps li').on('click',function () {
        if(jQuery(this).hasClass('active')){
            var a = jQuery(this).index();
            fieldset.hide();
            fieldset.eq(a).show();
            jQuery(".progres_steps li").find('.pimp').removeClass('pimp_active');
            jQuery(this).addClass('active').find('.pimp').addClass('pimp_active');
        }   else{
            lightempty();
        }
    });

    //=============== Form 2 =================\\

    var name2 = jQuery('#name_client_2');
    var email2 = jQuery('#email_client_2');
    var count2 = jQuery('#count_client_2');
    var phone2 = jQuery('#phone_client_2');

    jQuery('#form_more_person_tour .rqfield').addClass('empty_field');


    name2.blur(function () {
        if(name2.val() !== ''){
            if(name2.val().length > 5 && name.val().search(pattetn_number) === -1 ){

                jQuery(this).removeClass('empty_field').removeClass('error_input').addClass('validate_input');
            }else{
                jQuery(this).removeClass('validate_input').addClass('error_input');
            }
        } else{
            jQuery(name2).removeClass('validate_input').addClass('error_input');
        }
    });

    email2.blur(function () {
        if(email2.val() !== ''){
            if(email2.val().search(pattern_email) === 0 ){
                jQuery(this).removeClass('empty_field').removeClass('error_input').addClass('validate_input');
            }else{
                jQuery(this).removeClass('validate_input').addClass('error_input');
            }
        } else{
            jQuery(email2).removeClass('validate_input').addClass('error_input');
        }
    });

    only_number_input(count2);
    only_number_input(phone2);

    setInterval(function () {
        var validTrue = jQuery('.validate_input').length;


        if (validTrue >= 4){
            jQuery('#form2_submit').removeClass('disabled_btn');
        }
        else {
            jQuery('.section_registration input[type="submit"]').hide();
        }
        // console.log(validTrue);
    },500);

    jQuery('#form2_submit').on('click', function (e) {
       if(jQuery(this).hasClass('disabled_btn')){

           jQuery('#form_more_person_tour').find('.empty_field').addClass('error_input');

           e.preventDefault();
       } else{
           jQuery('#form_more_person_tour').submit();
       }
    });

});

jQuery(function () {
    jQuery('.pimp_container li').each(function(i) {
        jQuery(this).delay((i) * 500).fadeTo(1000, 1);
    });
});


jQuery(document).ready(function(){
    // wordpress admin panel
    jQuery('html').attr('style', 'margin-top: 0!important');
    jQuery('#wpadminbar').addClass('overflow');
    var hide;
    jQuery('#wpadminbar').on('mouseover', function(){
        setTimeout(function(){
            jQuery('#wpadminbar').removeClass('overflow');
        },1000);
        if(!jQuery('#wpadminbar').hasClass('open')){
            jQuery('#wpadminbar').addClass('open overflow');
        } else{
            clearTimeout(hide);
        }
    });
    jQuery('#wpadminbar').on('mouseleave', function(){
        hide = setTimeout(function(){
            jQuery('#wpadminbar').addClass('overflow');
            jQuery('#wpadminbar').removeClass('open');
        },2000);
    });
    // end wordpress admin panel
});







